import highlighterSvg from "@/components/sketch/assets/highlighter.svg?raw"
import { cn } from "@/lib/utils"

type Props = {
  color: string
  className?: string
}

/** Highlighter tip icon; tip fill uses currentColor from `color`. Source: assets/highlighter.svg */
export function SketchHighlighterIcon({ color, className }: Props) {
  return (
    <span
      aria-hidden
      className={cn("inline-flex [&>svg]:h-full [&>svg]:w-full", className)}
      style={{ color }}
      dangerouslySetInnerHTML={{ __html: highlighterSvg }}
    />
  )
}
